<div class="tag" [ngClass]="tagClasses">
  <div #element class="tag-content"
       [class.empty]="element | isStaticTagEmpty"
  >
    <ng-content></ng-content>
  </div>
</div>
